import { Badge, Button, Transition } from "@mantine/core";
import { ArrowDown } from "../assets";

interface NewMessageButtonProps {
    shouldShow: boolean;
    num: number;
    onClick: () => void;
}

function NewNotificationBadge({ num }: Omit<NewMessageButtonProps, "onClick" | "shouldShow">) {
    return (
        <Badge size="sm" circle>
            {num}
        </Badge>
    );
}

export function NewMessageButton({ shouldShow, num, onClick }: NewMessageButtonProps) {
    return (
        <Transition duration={400} mounted={shouldShow} transition="slide-up" timingFunction="ease">
            {(transitionStyles) => (
                <Button
                    color="dark.7"
                    size="sm"
                    leftSection={<NewNotificationBadge num={num} />}
                    onClick={onClick}
                    rightSection={<ArrowDown />}
                    style={{ ...transitionStyles, border: ` 0.125rem solid var(--mantine-color-primary-7)` }}
                >
                    {num > 1 ? "New messages" : "New message"}
                </Button>
            )}
        </Transition>
    );
}
